import type { RosOutcome } from './types'

// Исход за период: «Ушло в счёт» / «Ушло в отказ» + бар конверсии квота→счёт.
// Клики открывают модалку-список за период (16.07) — в очередь не ведут:
// у неё нет периода, а позиции отказных заявок в ней вообще не видны.

export function RosOutcomeCard({
  outcome,
  onOpenDrill,
}: {
  outcome: RosOutcome
  onOpenDrill: (kind: 'invoice' | 'refusal') => void
}) {
  const pct = outcome.conversionPct
  return (
    <div className="bg-white rounded-2xl border border-gray-200 p-4 h-full flex flex-col">
      <div className="text-sm text-gray-500 mb-3">Исход за период</div>
      <div className="grid grid-cols-2 gap-3">
        <button
          onClick={() => onOpenDrill('invoice')}
          className="rounded-xl border border-emerald-100 bg-emerald-50/60 p-3 text-left hover:-translate-y-0.5 transition-transform"
          title="Список позиций, ушедших в счёт за период"
        >
          <div className="text-2xl font-bold text-emerald-700 tabular-nums">
            {outcome.toInvoice.toLocaleString('ru-RU')}
          </div>
          <div className="text-xs text-gray-600 mt-0.5">Ушло в счёт →</div>
        </button>
        <button
          onClick={() => onOpenDrill('refusal')}
          className="rounded-xl border border-red-100 bg-red-50/60 p-3 text-left hover:-translate-y-0.5 transition-transform"
          title="Список позиций, ушедших в отказ за период"
        >
          <div className="text-2xl font-bold text-red-700 tabular-nums">
            {outcome.toRefusal.toLocaleString('ru-RU')}
          </div>
          <div className="text-xs text-gray-600 mt-0.5">Ушло в отказ →</div>
        </button>
      </div>

      <div className="mt-4">
        <div className="flex items-center justify-between text-xs text-gray-500 mb-1">
          <span>Конверсия квота → счёт</span>
          <span className="font-semibold text-gray-900">{pct === null ? '—' : `${pct}%`}</span>
        </div>
        <div className="h-2 bg-gray-100 rounded overflow-hidden">
          <div
            className="h-full rounded bg-emerald-500 transition-all"
            style={{ width: `${Math.min(100, Math.max(pct ?? 0, pct === null ? 0 : 2))}%` }}
          />
        </div>
      </div>
    </div>
  )
}
